<template>
  <div class="sidebar">
    <div class="sidebar-logo">
      <span v-if="!collapsed" class="logo-text">TOOAO</span>
      <span v-else class="logo-text-short">TOOAO</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      :collapse="collapsed"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <el-menu-item
        v-if="canShowMenu('dashboard')"
        index="/admin/dashboard"
      >
        <i class="el-icon-s-data" />
        <span slot="title">仪表盘</span>
      </el-menu-item>

      <el-submenu
        v-if="showGroupMessage"
        index="/admin/message-group"
      >
        <template slot="title">
          <i class="el-icon-bell" />
          <span slot="title">消息中心</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('announcement')"
          index="/admin/system-settings/announcements"
        >
          <span>通知公告</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_feedback')"
          index="/admin/system-settings/feedback"
        >
          <span>问题反馈</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupEmployee"
        index="/admin/employee-group"
      >
        <template slot="title">
          <i class="el-icon-user-solid" />
          <span slot="title">员工管理</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('employee_profile')"
          index="/admin/employees"
        >
          <span>员工列表</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('employee_salary')"
          index="/admin/salary-manage"
        >
          <span>薪资管理</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupAppraisal"
        index="/admin/appraisal-group"
      >
        <template slot="title">
          <i class="el-icon-data-analysis" />
          <span slot="title">考核管理</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('appraisal_settings')"
          index="/admin/appraisal/settings"
        >
          <span>考核设置</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('appraisal_manage')"
          index="/admin/appraisal/records"
        >
          <span>考核管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('appraisal_stats')"
          index="/admin/appraisal/stats"
        >
          <span>考核统计</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupSalary"
        index="/admin/salary-slip-group"
      >
        <template slot="title">
          <i class="el-icon-tickets" />
          <span slot="title">工资条</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('salary_dashboard')"
          index="/admin/salary-dashboard"
        >
          <span>工资条仪表盘</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('salary_history')"
          index="/admin/upload-history"
        >
          <span>工资条管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('salary_record')"
          index="/admin/salary-records"
        >
          <span>工资记录</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupProject"
        index="/admin/projects-group"
      >
        <template slot="title">
          <i class="el-icon-office-building" />
          <span slot="title">项目管理</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('project_dashboard')"
          index="/admin/project-dashboard"
        >
          <span>项目仪表盘</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('project_client')"
          index="/admin/clients"
        >
          <span>单位管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('project_manage')"
          index="/admin/projects"
        >
          <span>项目管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('project_payment')"
          index="/admin/project-payments"
        >
          <span>项目收款</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('project_settlement')"
          index="/admin/project-settlements"
        >
          <span>项目结算</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('partner_settlement')"
          index="/admin/partner-settlements"
        >
          <span>合伙人结算</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupFinance"
        index="/admin/finance"
      >
        <template slot="title">
          <i class="el-icon-money" />
          <span slot="title">财务管理</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('finance_dashboard')"
          index="/admin/finance/dashboard"
        >
          <span>财务仪表盘</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_income')"
          index="/admin/finance/income-vouchers"
        >
          <span>收入单</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_expense')"
          index="/admin/finance/expense-vouchers"
        >
          <span>支出单</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_transfer')"
          index="/admin/finance/transfer-vouchers"
        >
          <span>转账单</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_account')"
          index="/admin/finance/fund-accounts"
        >
          <span>资金账户</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_category')"
          index="/admin/finance/categories"
        >
          <span>收支项目</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_partner')"
          index="/admin/finance/partners"
        >
          <span>往来单位</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('finance_other_record')"
          index="/admin/finance/other-records"
        >
          <span>其他记录</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupCompany"
        index="/admin/company"
      >
        <template slot="title">
          <i class="el-icon-files" />
          <span slot="title">企业中心</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('company_overview')"
          index="/admin/company/overview"
        >
          <span>企业资料概览</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_qualification')"
          index="/admin/company/qualifications"
        >
          <span>企业资质证照</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_license')"
          index="/admin/company/licenses"
        >
          <span>银行/税务/印章证照</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_ipr')"
          index="/admin/company/iprs"
        >
          <span>知识产权证书</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_account')"
          index="/admin/company/accounts"
        >
          <span>企业账号管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_contract')"
          index="/admin/company/contracts"
        >
          <span>行政合同&模板库</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_project_contract')"
          index="/admin/company/project-contracts"
        >
          <span>项目合同</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('company_general')"
          index="/admin/company/general"
        >
          <span>通用资料</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupApproval"
        index="/admin/approval"
      >
        <template slot="title">
          <i class="el-icon-s-check" />
          <span slot="title">审批中心</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('approval_type')"
          index="/admin/approval/types"
        >
          <span>申请类型</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('approval_flow')"
          index="/admin/approval/flows"
        >
          <span>审批流管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('approval_center')"
          index="/admin/approval/center"
        >
          <span>申请办理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('approval_comp')"
          index="/admin/approval/comp"
        >
          <span>调休余额</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('leave_quota')"
          index="/admin/approval/leave"
        >
          <span>假期额度</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="showGroupSystem"
        index="/admin/system-settings"
      >
        <template slot="title">
          <i class="el-icon-setting" />
          <span slot="title">系统设置</span>
        </template>
        <el-menu-item
          v-if="canShowMenu('system_organization')"
          index="/admin/system-settings/organization"
        >
          <span>组织管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_holiday')"
          index="/admin/system-settings/holiday"
        >
          <span>假期管理</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_email')"
          index="/admin/system-settings/email"
        >
          <span>邮箱配置</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_settings')"
          index="/admin/system-settings/work-time"
        >
          <span>工作时长设置</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_employee_menu')"
          index="/admin/system-settings/employee-menus"
        >
          <span>员工端菜单</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_column')"
          index="/admin/system-settings/column-config"
        >
          <span>列配置</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_login_log')"
          index="/admin/system-settings/login-logs"
        >
          <span>登录日志</span>
        </el-menu-item>
        <el-menu-item
          v-if="canShowMenu('system_operation_log')"
          index="/admin/system-settings/operation-logs"
        >
          <span>操作日志</span>
        </el-menu-item>
        <!-- 角色管理：超级管理员或持有 role 权限键的角色可见 -->
        <el-menu-item
          v-if="$isAdmin() || $hasPerm('role', 'read')"
          index="/admin/system-settings/roles"
        >
          <span>角色管理</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// 一个分组只要有任意一个子菜单可见，就显示该分组
const GROUP_MAP = {
  message: ['announcement', 'system_feedback'],
  employee: ['employee_profile', 'employee_salary'],
  appraisal: ['appraisal_settings', 'appraisal_manage', 'appraisal_stats'],
  salary: ['salary_dashboard', 'salary_upload', 'salary_history', 'salary_view', 'salary_record'],
  project: ['project_dashboard', 'project_client', 'project_manage', 'project_payment', 'project_settlement', 'partner_settlement'],
  finance: ['finance_dashboard', 'finance_income', 'finance_expense', 'finance_transfer', 'finance_account', 'finance_category', 'finance_partner', 'finance_other_record'],
  company: [
    'company_overview', 'company_qualification', 'company_license',
    'company_ipr', 'company_account', 'company_contract',
    'company_project_contract', 'company_general'
  ],
  approval: ['approval_type', 'approval_flow', 'approval_center', 'approval_comp', 'leave_quota'],
  system: ['system_organization', 'system_holiday', 'system_email', 'system_employee_menu', 'system_column', 'system_login_log', 'system_operation_log']
  // 角色管理单算：必须 $isAdmin()
}

export default {
  name: 'Sidebar',
  computed: {
    ...mapState('app', ['sidebarCollapsed']),
    collapsed() {
      return this.sidebarCollapsed
    },
    activeMenu() {
      const route = this.$route
      return route.path
    },
    showGroupMessage() {
      return GROUP_MAP.message.some(k => this.canShowMenu(k))
    },
    showGroupEmployee() {
      return GROUP_MAP.employee.some(k => this.canShowMenu(k))
    },
    showGroupAppraisal() {
      return GROUP_MAP.appraisal.some(k => this.canShowMenu(k))
    },
    showGroupSalary() {
      return GROUP_MAP.salary.some(k => this.canShowMenu(k))
    },
    showGroupProject() {
      return GROUP_MAP.project.some(k => this.canShowMenu(k))
    },
    showGroupFinance() {
      return GROUP_MAP.finance.some(k => this.canShowMenu(k))
    },
    showGroupCompany() {
      return GROUP_MAP.company.some(k => this.canShowMenu(k))
    },
    showGroupApproval() {
      return GROUP_MAP.approval.some(k => this.canShowMenu(k))
    },
    showGroupSystem() {
      // 系统设置分组：有任意可见子项 或 是超管（有角色管理）
      const hasSub = GROUP_MAP.system.some(k => this.canShowMenu(k))
      return hasSub || this.$isAdmin()
    }
  },
  methods: {
    canShowMenu(menuKey) {
      // admin 全可见，其他角色按 read 权限判断
      return this.$hasPerm(menuKey, 'read')
    }
  }
}
</script>

<style scoped>
.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #2b3f56;
  overflow: hidden;
}

.logo-text {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

.logo-text-short {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.el-menu {
  border-right: none;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
</style>
